import { render, staticRenderFns } from "./AuditLogreport.vue?vue&type=template&id=3181a010&scoped=true"
import script from "./AuditLogreport.vue?vue&type=script&lang=js"
export * from "./AuditLogreport.vue?vue&type=script&lang=js"
import style0 from "./AuditLogreport.vue?vue&type=style&index=0&id=3181a010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3181a010",
  null
  
)

export default component.exports